module.exports = __webpack_public_path__ + "static/media/ils-file-jpg.8fdb9b46.svg";